import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ChiaveConfig } from 'src/app/models/configurazioni/ChiaveConfig';
import { AttivitaReale } from 'src/app/models/didattica/attivita-reale';
import { StudenteEnanche } from 'src/app/models/didattica/studente-enanche';
import { Libretto } from 'src/app/models/idoneita/libretto';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { DataService } from 'src/app/services/data-service';
import { DidatticaService } from 'src/app/services/didattica-service';
import { RilevazionePresenzeService } from 'src/app/services/rilevazione-presenze-service';
import { UtilityService } from 'src/app/services/utility.service';
import { InfoPopoverComponent } from '../info-popover/info-popover.component';
import { of } from 'rxjs';
import { IdoneitaService } from 'src/app/services/idoneita-service';
import { Presenza } from 'src/app/models/rilevazione-presenze/presenza';
import { InfoSuddivisionePage } from 'src/app/info-suddivisione/info-suddivisione.page';

@Component({
    selector: 'app-ar-viewer',
    templateUrl: './ar-viewer.component.html',
    styleUrls: ['./ar-viewer.component.scss'],
    standalone: false
})
export class ArViewerComponent implements OnInit {
  createIulOnDate: string;
  enableArAction = false;
  hourleftviewlimit = 0.95;
  infostudentsviewlimit = 0.80;
  npresenze = 0;
  averageStuds = 0;
  nstudenti = 0;
  hideMods = true;
  oreRimanentiInteg = '0';
  showFreqNotOblig: boolean;
  classe: Libretto[];
  usaOreAD: boolean;
  protected showProgressBarRilHours = 0; // 0 visualizza tutto, 1 mostra solo, 2 mostra solo, 3 nascondi tutto
  useModulesFreq: boolean;
  dtLimiteRichiestablocco: Date;
  now: Date;
  giorniPermanenzaInfoGeoloc = 0;
  showCdsStu: boolean = this.configService.getConfigurazione(ChiaveConfig.SHOW_CDS_STU) === 'true';

  moderoglezione = 'p';

  constructor(public navCtrl: NavController,
              protected router: Router,
              public utilityService: UtilityService,
              private configService: ConfigService,
              private rilevazionePresenzeService: RilevazionePresenzeService,
              private didatticaService: DidatticaService,
              private idoneitaService: IdoneitaService,
              private translateService: TranslateService,
              private dataService: DataService,
              private popoverController: PopoverController
              ) {
    this.createIulOnDate = this.configService.getConfigurazione(ChiaveConfig.CREATE_IUL_ON_DATE);
    if (!this.createIulOnDate) {
      this.createIulOnDate = 'N';
    }

    if (this.configService.getConfigurazione(ChiaveConfig.SHOW_PROGRESSBAR_RIL_AND_HOURS)) {
      this.showProgressBarRilHours = this.configService.getConfigurazione(ChiaveConfig.SHOW_PROGRESSBAR_RIL_AND_HOURS);
      console.log('showprogress: ', this.showProgressBarRilHours);
    }

    this.showFreqNotOblig = this.configService.getConfigurazione(
      ChiaveConfig.SHOW_FREQ_NOT_OBLIG
    ) === 'true';

    this.useModulesFreq = this.configService.getConfigurazione(ChiaveConfig.USE_MODULES_FREQ) === 'true';

    this.giorniPermanenzaInfoGeoloc = this.configService.getConfigurazione(ChiaveConfig.GIORNI_PERMANENZA_INFO_GEOLOC);

    console.log('this.showCdsStu', this.showCdsStu);

  }

  @Input() ar: AttivitaReale;
  @Input() viewasstudent: boolean;
  @Input() errorMessage: string;
  @Input() showHistoryLink = true;
  @Input() showProgressBar = true;
  @Input() showStudentProgressBar = false;
  @Input() showReport = false;
  @Input() showImpegni = false;
  @Input() idoneitaMode = false;
  @Input() showActionArrow = true;
  @Input() navigateIntegMods = true;
  @Input() loadPresenze = true;
  @Input() forceBackArrowUse = false;
  @Input() usaOreADVal = false;
  @Input() freqVsTotAr = false;

  @Output() arSelected = new EventEmitter();
  @Output() studentiLoaded = new EventEmitter();
  studenti: StudenteEnanche[];
  daterilmin: any;
  daterilmax: any;

  async ngOnInit() {
    this.now = (new Date);
    console.log('this.loadPresenze', this.loadPresenze);
    this.usaOreAD = this.idoneitaMode;
    if (this.usaOreADVal) {
      this.usaOreAD = this.usaOreADVal;
    }

    if (this.viewasstudent) {
      console.log('ar viewer ngOnInit as Studente');
      console.log('ar', this.ar);
      if (this.ar.moduliInteg) {
       this.calcolaStatsInteg();
      }

      let esitonoPresenzeGeolocalizzate = false;
      if (this.ar.presenze) {
        const presenzeGeolocalizzate = this.ar.presenze.filter(pres => {
          return (pres.latitudine);
        });
        esitonoPresenzeGeolocalizzate = presenzeGeolocalizzate.length > 0;
      }
      if (!esitonoPresenzeGeolocalizzate) {
        this.giorniPermanenzaInfoGeoloc = 0;
      } else {
        if (this.ar.idoneitaStudente) {
          const gpig = this.giorniPermanenzaInfoGeoloc;
          this.dtLimiteRichiestablocco = new Date(this.ar.idoneitaStudente.istanteUltimaModifica);
          this.dtLimiteRichiestablocco = new Date( this.dtLimiteRichiestablocco.getTime() + (gpig * 24 * 60 * 60 * 1000) );
          this.dtLimiteRichiestablocco.setHours(23);
          this.dtLimiteRichiestablocco.setMinutes(59);
          this.dtLimiteRichiestablocco.setSeconds(59);
          console.log('this.ar.idoneitaStudente.istanteUltimaModifica', this.ar.idoneitaStudente.istanteUltimaModifica);
          console.log('giorni Permanenza Info Geoloc', gpig)
          console.log('this.dtLimiteRichiestablocco', this.dtLimiteRichiestablocco);
          if (this.now.getTime() > this.dtLimiteRichiestablocco.getTime()) { // passato il limite, imposta a 0 this.giorniPermanenzaInfoGeoloc
            this.giorniPermanenzaInfoGeoloc = 0;
          }
        }
      }
    } else {
      console.log('ar viewer ngOnInit as Docente');
      // integrato
      if (this.ar.moduliInteg) {
        if (!this.ar.presenze) {
          console.log('xx integrato', this.ar.integDesc);
          if (this.loadPresenze) {
            await this.idoneitaService.recuperaPresenzeARInteg(this.ar);
            await this.parseStudentiFromPresenze();
          } else {
            this.countStudentiInteg(this.ar);
          }
          this.calcolaStatsInteg();
        } else {
          await this.parseStudentiFromPresenze();
        }
      } else {
        // modulo di un integrato o  AD non integrata
        if (!this.viewasstudent && this.ar.rilevazioni && this.ar.rilevazioni.length > 0) { // va fatto solo se richiamata da docente
            if (this.loadPresenze) {
              // tslint:disable-next-line:max-line-length
              if (!this.idoneitaMode // caricamnto delle presenze nel caso in cui il componente non è caricato da una delle pagine di gestione delle idoneità
                    ||
                    // tslint:disable-next-line:max-line-length
                   (this.idoneitaMode && !this.ar.afGenIntegCod)) { // caricamnto delle presenze nel caso in cui il componente è caricato da una delle pagine di gestione delle idoneità ma non fa parte di un integrato
                  // recupera la "classe" di studenti
                this.classe = await this.getClasseAD();
                console.log('classe recuperata');
                await this.recuperaStudentiAR();
                console.log('studenti ar recuperati');
              } else {
                if (this.ar.presenze) {
                  this.elaboraPresenzeAR();
                }
              }
            }
            this.countStudentiAR(this.ar);
            this.daterilmin = this.utilityService.getArrayMinByProp(this.ar.rilevazioni, 'istanteCreazione');
            this.daterilmax = this.utilityService.getArrayMaxByProp(this.ar.rilevazioni, 'istanteCreazione');

            this.npresenze = this.ar.rilevazioni.reduce((sum, nextRil) =>
                    sum + nextRil.numeroPresenze, 0);
            this.averageStuds = Math.round( this.npresenze / this.ar.rilevazioni.length) ;
            // console.log('studs', this.studs);
            // console.log('this.ar.rilevazioni.length', this.ar.rilevazioni.length);
            // console.log('averageStuds', this.averageStuds);
        }
        // nel caso in cui non siano state recuperate rilevazioni e quindi presenze
        // emette comunque l'evento di caricamento degli studenti per dismettere il loader
        if (this.loadPresenze && (!this.ar.rilevazioni || this.ar.rilevazioni.length === 0)) {
          this.studentiLoaded.emit(this.studenti);
        }
      }

    }
    if (this.showImpegni) {
      this.showActionArrow = false;
    }
    if (!this.navigateIntegMods && this.ar.afGenIntegCod) { // è un modulo
      this.showActionArrow = false;
    }
    if (this.forceBackArrowUse) {
      this.showActionArrow = true;
    }

    this.setEnableArAction();
    this.calcoloOreRimanentiInteg();
    this.calcolaErogazioneMin();

  }

  async getClasseAD(): Promise<Libretto[]> {
    return this.didatticaService.cercaClasseAttivitaReale(this.ar).toPromise();
  }

  async recuperaStudentiAR() {
    console.log('recuperaStudentiAR', (new Date()).toLocaleTimeString());
    console.log('this.ar.id', this.ar.id);

    // verifica che le rilevazioni associate alla ar abbiano davvero tutte la stessa ar. 
    // In caso contrario vanno recuperate le presenze di tutte le ar trovate sulle ril
    const arList = [];
    let i = 0;
    for (const ril of  this.ar.rilevazioni ) {
      console.log('ril', ril);
      if (ril.ar && this.ar.id !== ril.ar.id) {
        arList[i] = ril.ar;
        i++;
      }
    }

    if (arList.length > 0) {
      arList.push(this.ar);
      this.getPresenzeFromArList(arList);
    } else {
      this.rilevazionePresenzeService.getPresenzeAR(this.ar)
      .subscribe({
        next: list => {
          this.ar.presenze = list; // elenco di tutte le presenze
          this.elaboraPresenzeAR();
          },
        error: error => {
          throw error;
        }
      });
    }

  }

  async getPresenzeFromArList(arList: any[]) {
    let presenze: Presenza[]= [];
    for (const ar of  arList ) {
      const prs = await this.getPresenzeFromAr(ar);
      if (prs) {
        presenze = presenze.concat(prs);
      }
    }
    this.ar.presenze = presenze;
    this.elaboraPresenzeAR();
  }

  async getPresenzeFromAr(ar): Promise<Presenza[]> {
    return this.rilevazionePresenzeService.getPresenzeAR(ar).toPromise();
  }


  async elaboraPresenzeAR() {
    console.log('elaboraPresenzeAR', (new Date()).toLocaleTimeString());
    if (this.ar.presenze) {
      this.studenti = this.rilevazionePresenzeService.parsePresenze(this.ar, this.usaOreAD);
      // vanno sovrascritte le info di frequenza se presenti sulla classe
      this.addInfoLibretto(this.studenti);
      this.nstudenti = this.studenti.length;
      console.log('this.studenti for ' + this.ar.afGenCod, this.studenti);
      this.studentiLoaded.emit(this.studenti);
    }
  }

  addInfoLibretto(studenti: StudenteEnanche[]) {
    const localStudenti = studenti.filter(stud => {
      if (this.classe  && this.classe.length > 0) {
          stud.freqinfo.frequenza = this.utilityService.addInfoLibretto(this.classe, stud, this.ar.ore, false);
      }
      return (true);
    });
  }

  async countStudentiAR(ar: AttivitaReale) {
    console.log('countStudentiAR', (new Date()).toLocaleTimeString());
    console.log('countStudentiAR ar ', ar);
    if (ar.docentiModuli) {
      const idArs = [];
        for (const doc of ar.docentiModuli) {
            idArs.push(doc.moduloInteg.id);
          }
          this.rilevazionePresenzeService.countStudentiMultipleAR(idArs).subscribe((n) => {
            this.nstudenti = n;
          });
    } else {
      this.rilevazionePresenzeService.countStudentiAR(ar)
      .subscribe(
        n => {
          this.nstudenti = n;
          console.log('this.nstudenti for ' + this.ar.afGenCod, this.nstudenti);
          },
        error => {
          throw error;
        }
      );
    }
  }

  calcolaStatsInteg() {
    // console.log('calcolaStatsInteg', (new Date()).toLocaleTimeString());
    this.ar.rilevazioni = null;
    // potrebbero essere stati accorpati ma per il conteggio delle presenze il recupero delle rilevazioni deve utilizzare gli originali
    const moduli = this.ar.moduliIntegNonAccorp ? this.ar.moduliIntegNonAccorp : this.ar.moduliInteg;
    for (const modulo of  moduli ) {
      if (this.ar.rilevazioni) {
        this.ar.rilevazioni = this.ar.rilevazioni.concat(modulo.rilevazioni);
      } else {
        this.ar.rilevazioni = modulo.rilevazioni;
      }
      if (modulo.rilevazioni) {
        this.npresenze += modulo.rilevazioni.reduce((sum, nextRil) =>
          sum + nextRil.numeroPresenze, 0);
      }
    }
    if (this.ar.rilevazioni) {
      this.averageStuds = Math.round( this.npresenze / this.ar.rilevazioni.length) ;
    }
    console.log('zz narril for integCod ' + this.ar.afGenIntegCod, this.ar.rilevazioni? this.ar.rilevazioni.length: 0);
    console.log('zz this.averageStuds ' + this.ar.afGenIntegCod, this.averageStuds);

  }


  async countStudentiInteg(ar: AttivitaReale) {
    console.log('countStudentiInteg' , ar);
    // loop sugli integrati per contare tutte le presenze
    const idArs = [];
    const moduli = ar.moduliIntegNonAccorp ? ar.moduliIntegNonAccorp : ar.moduliInteg;
    for (const modulo of  moduli ) {
      idArs.push(modulo.id);
    }
    this.rilevazionePresenzeService.countStudentiMultipleAR(idArs).subscribe((n) => {
      this.nstudenti = n;
    });
  }

  async contaPresenzeARInteg(ar: AttivitaReale) {
    console.log('contaPresenzeARInteg' , ar);
    // loop sugli integrati per contare tutte le presenze
    const moduli = ar.moduliIntegNonAccorp ? ar.moduliIntegNonAccorp : ar.moduliInteg;
    for (const modulo of  moduli ) {
      const pres = await this.countStudentiAR(modulo);
      console.log('contaPresenzeARInteg modulo ' , modulo);
      console.log('contaPresenzeARInteg pres ' , pres);
      // modulo.presenze = pres;
      // if (this.ar.presenze) {
      //   this.ar.presenze = this.ar.presenze.concat(pres);
      // } else {
      //   this.ar.presenze = pres;
      // }
    }
    // console.log('contaPresenzeARInteg n presenze ', this.ar);
  }


  async parseStudentiFromPresenze(): Promise<boolean> {
    this.studenti = this.idoneitaService.parseStudentiFromPresenze(this.ar, this.usaOreAD);
    this.nstudenti = this.studenti.length;
    this.studentiLoaded.emit(this.studenti);
    return of(true).toPromise();
  }

  seleziona(ar: AttivitaReale) {
    if (this.enableArAction) {
      console.log('emit ar', ar);
      if (ar.impegnoDocente) {
        ar.impegnoDocente.modalitaErogazione = this.moderoglezione;
      }
      this.arSelected.emit(ar);
    }
  }

  selezionaModulo(ar: AttivitaReale) {
    // va realizzato un componente da aprire in una modale per visualizzare i frequentanti del modulo

    // if (this.ar.presenze) {
    //   this.dataService.attivitaReale = ar;
    //   this.dataService.docente = ar.docente;
    //   this.dataService.idoneita = undefined;
    //   this.router.navigate(['idoneita-studenti', {forceBackArrowUse : true}] );
    // }
  }


  async goToHistory(ar: AttivitaReale) {
    this.utilityService.showHint(this.translateService.instant('ar-viewer-component.hints.show-history'));
    this.dataService.attivitaReale = ar;
    this.navCtrl.navigateForward('storico-rilevazioni-per-ar');
  }


  setEnableArAction() {

    let countPerc = 0;

    if (this.idoneitaMode) {
      this.enableArAction = false;
      const percMinInvioIdoneita = this.configService.getConfigurazione(ChiaveConfig.PERC_MIN_INVIO_IDONEITA);
      if (this.ar.moduliInteg && this.useModulesFreq && !this.ar.moduloMonoDisc) {

        // siamo all'interno della verifica di superamento di ogni singolo modulo. 
        // La verifica che segue non serve perché se l'erogazione è corretta per tutti i moduli lo sarà anche per il totale
        // if ( this.ar.totaleMinuti / 60 >= this.ar.ore ) {
        //   this.enableArAction = true;
        // }

        this.ar.moduliInteg.forEach(function (modulo) {
            const consentiInvio = modulo.percentualeLezioni() >= percMinInvioIdoneita / 100;
            if ( consentiInvio ) {
              countPerc++;
            }
          }
        );

        if (countPerc === this.ar.moduliInteg.length) {
          this.enableArAction = true;
        } else {
          this.enableArAction = false;
        }
      } else {
        this.enableArAction = this.ar.percentualeLezioni() >= percMinInvioIdoneita / 100;
      }

      if (!this.enableArAction) {
        console.log('controllo soglia minima di erogazione non superato');
        return;
      }

      if (!this.configService.indicaTipoAttivita) {
        return;
      }
      // qui va valutato il rispetto della suddivisione in ore per tipo di attività didattica
      const oreMinTipoAttivita = this.utilityService.getMinOreTipoAttivita();
      countPerc = 0;
      if (oreMinTipoAttivita.length > 0) {
        console.log('oreMinTipoAttivita: ', oreMinTipoAttivita);

        this.ar.suddivisioneOre.forEach(function (sudd) {
            const suddmin = oreMinTipoAttivita.find(suddmin => sudd.cod === suddmin.cod);
            let oreminperc = suddmin?.ore?? 0;
            oreminperc = oreminperc / 100;
            console.log('sudd.percErog', sudd.percErog); 
            console.log('oreminperc', oreminperc); 
            const consentiInvio = sudd.percErog >= oreminperc;
            if ( consentiInvio ) {
              countPerc++;
            }
          }
        );
        if (countPerc === this.ar.suddivisioneOre.length) {
          this.enableArAction = true;
          console.log('controllo del rispetto delle suddivisioni superato');
        } else {
          this.enableArAction = false;
          console.log('controllo del rispetto delle suddivisioni NON superato');
        }
      }
      return;
    }

    if (this.viewasstudent) {
      this.enableArAction = true;
      return;
    }
    // console.log('this.ar.dataIniAtt', this.ar.dataIniAtt);
    // console.log('this.ar.dataIniAtt ms ' + this.ar.dataIniAtt.valueOf().valueOf());
    // console.log('this.ar.dataFineAtt', this.ar.dataFineAtt);
    // console.log('this.ar.dataFineAtt ms ' + this.ar.dataFineAtt.valueOf().toString());
    // verifica il valore del par conf CREATE_IUL_ON_DATE: per stabilire se abilitare o meno la creazione della iul
    this.enableArAction = false;
    // se la data di inizio attività non dovesse essere impostata da sempre la possibilità di creare la IUL
    if ( !this.ar.dataIniAtt ) {
      this.enableArAction = true;
    }

    if (!this.enableArAction) {
      // now = new Date( ( now.valueOf()) + 2600000000 * 9); // + 9 mesi circa
      switch (this.createIulOnDate) {
        case 'N':  // "no control"               N non effettua controllo sulle date inizio e fine attività
          this.enableArAction = true;
          break;
        case 'B':  // "strictly_on_date_between" B la data odierna dev essere compresa negli estremi del range
          if (this.ar.dataIniAtt && this.ar.dataFineAtt) {
            if ( this.now >= this.ar.dataIniAtt && this.now <= this.ar.dataFineAtt ) {
              this.enableArAction = true;
            }
          }
          break;
        case 'S':  // "strictly_on_start_date"   S la data odierna > data_inizio_attività, controllo solo sulla data di inizio
        if (this.ar.dataIniAtt) {
          if ( this.now >= this.ar.dataIniAtt ) {
            this.enableArAction = true;
          }
        }
        break;
      }
    }
    // console.log('this.setEnableArAction', this.enableArAction);
  }

  showHideMods() {
    this.hideMods = !this.hideMods;
  }

  showSudd(event: Event) {
    const modalResp = this.utilityService.showModal(InfoSuddivisionePage, 
      { 
      suddivisioneOre: this.viewasstudent? this.ar.studenti[0].freqinfo.suddivisioneOre: this.ar.suddivisioneOre,
      viewAsStudent: this.viewasstudent
      }, '', true);
      event.stopPropagation();
  }

  showHint(mess, event) {
    this.utilityService.showHintNoProp(mess, null, event);
  }

  async showNoteImpegno(ev) {
    const datas = {
      notePubbliche: this.ar.impegnoDocente.notePubbliche
    };
    // console.log(datas);
    const popover = await this.popoverController.create({
      component: InfoPopoverComponent,
      event: ev,
      componentProps: {datas: datas},
      showBackdrop: false,
      cssClass: 'info-popover'
    });
    popover.present();
  }

  async showInfoAulaImpegno(ev) {
    ev.stopPropagation();
    const datas = {
      aula: this.ar.impegnoDocente.aula,
      edificio: this.ar.impegnoDocente.edificio
    };
    // console.log(datas);
    const popover = await this.popoverController.create({
      component: InfoPopoverComponent,
      event: ev,
      componentProps: {datas: datas},
      showBackdrop: false,
      cssClass: 'info-popover'
    });
    popover.present();
  }

  showInfoOreCorrette() {
    if ((this.ar.ore - this.ar.totaleMinuti / 60) > 0) {
      this.utilityService.showHint(this.translateService.instant('ar-viewer-component.hints.left-hours'));
    } else {
      this.utilityService.showHint(this.translateService.instant('ar-viewer-component.hints.out-hours'));
    }
  }

  calcoloOreRimanentiInteg() {
    let oreRimanenti = 0;
    if (this.ar.moduliInteg) {
      this.ar.moduliInteg.forEach(mod => {
        if (mod.percentualeLezioni() < 1) {
          // this.oreRimanentiInteg += mod.percentualeLezioni() > 1 ? (mod.totaleMinuti / 60 - mod.ore) : (mod.ore - mod.totaleMinuti / 60);
          oreRimanenti += mod.percentualeLezioni() > 1 ? (mod.totaleMinuti - mod.ore * 60) : (mod.ore * 60 - mod.totaleMinuti );
        }
      });
    }
    this.oreRimanentiInteg = this.utilityService.formatDurata(oreRimanenti);
  }

  calcolaErogazioneMin() {
    // Se FREQ_OBBLIG_FLG=1
    // Le informazioni di minimo sono espresse dall'attribto oreMinFreq, la percentuale minima sul campo percOreFreq
    // Per ril calcolo della percentuale minima da erogare, i due campi sono in alternativa.
    // Nel caso in cui percOreFreq sia nullo, valgoo le ore minime e viceversa

    if (this.ar.freqObbligFlg === 1) {
      if (!this.ar.oreMinFreq && this.ar.percOreFreq ) {
        this.ar.oreMinFreq = this.ar.percOreFreq * this.ar.ore / 100;
      }
      if (this.ar.oreMinFreq && !this.ar.percOreFreq ) {
        this.ar.percOreFreq = Math.trunc((this.ar.oreMinFreq * 100) / this.ar.ore);
      }
    }
  }

  negaGeolocCleaning(ar: AttivitaReale) {
    let saveConfirmMessage = this.translateService.instant('ar-viewer.message.enable-geoloc-dispute.askconfirm');
    this.utilityService.presentAlertConfirmCancel(
      saveConfirmMessage,
      this.translateService.instant('ar-viewer.button.ask-geoloc-clean-stop'),
      () =>  {
        this.idoneitaService.negaGeolocCleaning(ar.idoneitaStudente).subscribe((ist) => {
          ar.idoneitaStudente = ist;
        });
      }
    );
  }

  genModErogLezione(id: string): any {
    const rep = {id: id, name: this.translateService.instant('report.kinds.' + id) };
    return rep;
  }

  switchRadio(event: any) {
    this.moderoglezione = event;
    console.log('this.moderoglezione', this.moderoglezione);
  }

}
